/* eslint-disable */
import slickObject from 'slick-carousel';
import RevieveSDK from '../../../src/RevieveSDK';
import products from './makeupProducts';

require('bootstrap/dist/css/bootstrap.min.css');
require('bootstrap/dist/js/bootstrap.min.js');
require('../css/test.css');
require('../css/liveAR.css');

let categories = [
  'concealer',
  'bronzer',
  'highlighter',
  'mascara',
  'eyeshadow',
  'eyeliner',
  'blush',
  'lipstick',
  'lipliner',
  'foundation',
  'eyebrows',
  'hair',
];
let UIstate = {
  activeCategory: 'lipstick',
  activeProducts: {},
  selectedColors: {},
  categoriesEffectVisible: {
    concealer: true,
    bronzer: true,
    highlighter: true,
    mascara: true,
    eyeshadow: true,
    eyeliner: true,
    blush: true,
    lipstick: true,
    lipliner: true,
    concealer: true,
    foundation: true,
    eyebrows: true,
    hair: true,
  },
  beautify: true,
};
let slickIndexes = {};
let revieveSDK;

const regex = /[?&]([^=#]+)=([^&#]*)/g;
const url = window.location.href;
const params = {};
let match;
do {
  match = regex.exec(url);
  if (match) params[match[1]] = match[2];
} while (match);

let configuration = {
  renderToSelector: '#imageContainer',
  partnerID: 'VweadehMqO',
  debug: params.debug,
};

let errorProcessingAdvanceTracking = false;
let continueDespiteAdvanceTrackingError = false;
let readyToRenderEffects = false;

const setContinueDespiteAdvanceTrackingError = () => {
  continueDespiteAdvanceTrackingError = true;
  readyToRenderEffects = true;
  $('.advanceTrackingGuides').hide();
  $('.initilazingCam').hide();
  $('#productsLoading').removeClass('visible');
  $('#productsLoading').addClass('hidden');
  $('#productsContainer').removeClass('hidden');
  $('#productsContainer').addClass('visible');
  updateUI();
};

const liveAREventHandler = ({ type, state, isError = false, currentRetry = 0, maxRetries = 0, errorMessage = '' }) => {
  const advanceTrackingInitText =
    '<h3>We are going to analyze your face to get some initial information to improve effects. <br/>Please, put your face inside the guides and ensure good light conditions.</h3>';
  const advanceTrackingErrorText =
    '<h3>We aren\'t able to analyze your face. Do you want to continue with basic tracking options?</h3><button onclick="liveARDemo.setContinueDespiteAdvanceTrackingError()">OK!</button>';
  const advanceTrackingProcessingText =
    '<img src="./testPage/img/loading_transparent.gif" /><br/><h3>We are analyzing your face to get advance tracking points. <br/>Please, put your face inside the guides and ensure good light conditions.</h3>';
  console.log(type);
  console.log(state);
  console.log(isError);
  switch (type) {
    case 'statusChanged':
      if (state === 'renderingEffects') {
        if (errorProcessingAdvanceTracking) {
          $('#productsLoading').html(advanceTrackingErrorText);
        }
        if (
          !errorProcessingAdvanceTracking ||
          (errorProcessingAdvanceTracking && continueDespiteAdvanceTrackingError)
        ) {
          readyToRenderEffects = true;
          $('.advanceTrackingGuides').hide();
          $('.initilazingCam').hide();
          $('#productsLoading').removeClass('visible');
          $('#productsLoading').addClass('hidden');
          $('#productsContainer').removeClass('hidden');
          $('#productsContainer').addClass('visible');
          updateUI();
        }
      }
      if (state === 'activatingAdvanceTracking') {
        $('.advanceTrackingGuides').show();
        $('.initilazingCam').hide();
        $('#productsLoading').html(advanceTrackingInitText);
      }
      break;
    case 'advanceTracking':
      if (state === 'waitingResponse') {
        $('.advanceTrackingGuides').show();
        $('.initilazingCam').hide();
        if (!errorProcessingAdvanceTracking) {
          $('#productsLoading').html(advanceTrackingProcessingText);
        }
      }
      if (isError) {
        $('#productsLoading').html(
          `${advanceTrackingProcessingText}<h5>Attempt ${currentRetry} of ${maxRetries} - Error!!! - ${errorMessage}</h5>`,
        );
      }
      if (state === 'waitingUserFace') {
        errorProcessingAdvanceTracking = isError;
      }
      break;
    default:
  }

  if (state === 'noFaceDetected') {
    document.getElementById('faceWarning').style.display = 'flex';
  } else {
    document.getElementById('faceWarning').style.display = 'none';
  }
};

const liveARInit = async ({ advanceTracking, mode }) => {
  const { partnerID, renderToSelector, debug } = configuration;
  revieveSDK = new RevieveSDK(partnerID, debug);
  let effects = {};
  categories.forEach((category) => {
    effects[category] = { enabled: false };
  });
  await revieveSDK.liveAR.initialize({
    renderToSelector,
    debug,
    effects,
    advanceTracking,
    mode,
    eventHandler: liveAREventHandler,
  });
};

const changeActiveCategoryEffectVisible = () => {
  const { activeCategory } = UIstate;
  UIstate.categoriesEffectVisible[activeCategory] = !UIstate.categoriesEffectVisible[activeCategory];
  updateUI();
};
const changeBeautifyEffectVisible = () => {
  UIstate.beautify = !UIstate.beautify;
  updateUI();
};

const selectProductColor = ({ id, index }) => {
  UIstate.selectedColors[id] = index;
  updateUI();
};

const getProductCardContent = (product) => `<div>
  <div id="${product.category}Product${product.id}" class="makeupProductCard">
    <div class="row">
      <div class="col-4">
        <img src="/test/testPage/img/${product.category}_${product.finish || product.image || ''}.png" />
        ${product.finish ? `<div class="finishDisplay">${product.finish.toUpperCase()}</div>` : ''}
      </div>
      <div class="col-8">
        <div class="colorSelector">
        ${product.colors
          .map(
            (color, idx) => `<div id="color_${product.id}_${idx}" class="colorDisplay" style="${
              Array.isArray(color[0])
                ? `background-image: linear-gradient(to right, rgb(${color[0]}) ,rgb(${color[1]}), rgb(${color[2]}));`
                : `background-color: rgb(${color[0]},${color[1]}, ${color[2]})`
            }" onclick="liveARDemo.selectProductColor({id:'${product.id}', index:'${idx}'})">
                      </div>`,
          )
          .join('')}
        </div>
        <h3>${product.name}</h3>
        <p>${product.description}</p>
      </div>
    </div>
  </div>
  </div>`;

const createCarousels = () => {
  const { activeCategory } = UIstate;
  let isFirst = true;
  products.forEach((product) => {
    if (product.category === activeCategory && isFirst) {
      UIstate.activeProducts[activeCategory] = product;
      isFirst = false;
    }
    UIstate.selectedColors[product.id] = 0;
    $(`#${product.category}Products`).append(getProductCardContent(product));
    if (!slickIndexes[product.category]) {
      slickIndexes[product.category] = [];
    }
    slickIndexes[product.category].push(product);
  });
  categories.forEach((category) => {
    $(`#${category}Products`).slick({
      dots: true,
      centerMode: true,
      swipeToSlide: true,
      infinite: false,
      touchMove: true,
      focusOnSelect: true,
      centerPadding: '60px',
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
          },
        },
      ],
    });
    $(`#${category}Products`).on('afterChange', (event, slick) => {
      UIstate.activeProducts[category] = slickIndexes[category][slick.currentSlide];
      updateUI();
    });
  });
};

const onLoadActions = async ({ advanceTracking = false, mode }) => {
  // eslint-disable-next-line no-undef
  Sentry.init({ dsn: 'https://0184b8fc4bdc4d03800a5aba4c1c7f70@sentry.io/1436419' });
  await liveARInit({ advanceTracking, mode });
  $('.categoriesElement').addClass('animated');
  $('#unmountButton').click(() => mountUnmountModule({ advanceTracking }));
  $('#getImageButton').click(() => {
    if (!revieveSDK.liveAR.getImage) return;
    $('.advanceTrackingGuides').show();
    const countDown = (step) => {
      $('#getImageCounter').text(step);
      setTimeout(async () => {
        const nextStep = step - 1;
        if (nextStep === 0) {
          $('#getImageCounter').text('');
          try {
            const image = await revieveSDK.liveAR.getImage({ width: 460, height: 800 });
            const element = document.createElement('a');
            element.setAttribute('href', image);
            element.setAttribute('download', 'resultsImage');
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
          } catch (e) {
            alert('The face has not been detected');
          }
          $('.advanceTrackingGuides').hide();
        } else {
          countDown(nextStep);
        }
      }, 1000);
    };
    countDown(3);
  });
  createCarousels();
  updateUI();

  if (mode === 'hair') {
    UIstate.activeCategory = 'hair';
    UIstate.activeProducts.hair = slickIndexes.hair[0];
    updateUI();
  }
};

const mountUnmountModule = ({ advanceTracking }) => {
  if (revieveSDK.liveAR.mounted) {
    revieveSDK.liveAR.release();
    $('#unmountButton').text('Mount component');
  } else {
    liveARInit({ advanceTracking });
    $('#unmountButton').text('Unmount component');
  }
};

const updateUI = () => {
  let { activeCategory, selectedColors, activeProducts, categoriesEffectVisible, beautify } = UIstate;
  categories.forEach((category) => {
    if (category === activeCategory) {
      $(`#${category}CategoryButton`).addClass('categorySelected');
      $(`#${category}Products`).removeClass('hidden');
      $(`#${category}Products`).addClass('visible');
    } else {
      $(`#${category}CategoryButton`).removeClass('categorySelected');
      $(`#${category}Products`).removeClass('visible');
      $(`#${category}Products`).addClass('hidden');
    }
  });
  let activeProduct = activeProducts[activeCategory];
  if (activeProduct) {
    activeProduct.colors.forEach((color, index) => {
      if (parseInt(selectedColors[activeProduct.id], 10) === parseInt(index, 10)) {
        $(`#color_${activeProduct.id}_${index}`).addClass('colorSelected');
      } else {
        $(`#color_${activeProduct.id}_${index}`).removeClass('colorSelected');
      }
    });
  }
  if (!categoriesEffectVisible[activeCategory]) {
    $('#effectActive').text('Not applied');
    $('#effectActive').addClass('notApplied');
  } else {
    $('#effectActive').text('Applied');
    $('#effectActive').removeClass('notApplied');
  }
  if (!beautify) {
    $('#beautifyActive').addClass('notApplied');
  } else {
    $('#beautifyActive').removeClass('notApplied');
  }
  renderLiveAREffects();
};

const renderLiveAREffects = () => {
  if (!readyToRenderEffects) return;
  const { activeCategory, categoriesEffectVisible, activeProducts, selectedColors, beautify } = UIstate;
  let effect = { beautify: { enabled: beautify } };
  let effectConfiguration = {};
  if (!categoriesEffectVisible[activeCategory]) {
    effectConfiguration = { enabled: false };
  } else {
    let activeProduct = activeProducts[activeCategory];
    if (activeProduct) {
      effectConfiguration = {
        enabled: true,
        color: activeProduct.colors[selectedColors[activeProduct.id]],
      };
      if (activeProduct.strength) {
        effectConfiguration.strength = activeProduct.strength;
      }
      if (activeProduct.finish) {
        effectConfiguration.finish = activeProduct.finish;
      }
      if (activeProduct.finishStrength) {
        effectConfiguration.finishStrength = activeProduct.finishStrength;
      }
      if (activeProduct.coverage) {
        effectConfiguration.coverage = activeProduct.coverage;
      }
      if (activeProduct.height) {
        effectConfiguration.height = activeProduct.height;
      }
      if (activeProduct.arc) {
        effectConfiguration.arc = activeProduct.arc;
      }
      if (activeProduct.type) {
        effectConfiguration.type = activeProduct.type;
      }
      if (activeProduct.offset) {
        effectConfiguration.offset = activeProduct.offset;
      }
      if (activeProduct.thickness) {
        effectConfiguration.thickness = activeProduct.thickness;
      }
    }
  }
  effect[activeCategory] = effectConfiguration;
  if (activeCategory === 'eyebrows') {
    effect.eyebrowsTransform = effectConfiguration;
  }

  if (revieveSDK.liveAR.changeEffects) revieveSDK.liveAR.changeEffects(effect);
};

const setUIState = ({ category }) => {
  UIstate.activeCategory = category;
  if (!UIstate.activeProducts[category] && slickIndexes[category]) {
    UIstate.activeProducts[category] = slickIndexes[category][0];
  }
  updateUI();
};

window.liveARDemo = {
  onLoadActions,
  setUIState,
  changeActiveCategoryEffectVisible,
  changeBeautifyEffectVisible,
  selectProductColor,
  setContinueDespiteAdvanceTrackingError,
};
